
import { POST } from "../../APiHelper/API";

export const repopulateShortNamesAPI = (team_id, onSuccess, onError) => {
    const data = {}
    POST(`/api/v1/leagues/team/${team_id}/repopulate_short_names`, data, onSuccess, onError)
}